/**
 * contains the abi and contract address
*/

class WallpaperContract {
    constructor() {
        this.abi = [
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "wallpaperHash",
				"type": "bytes32"
			}
		],
		"name": "DefaultWallpaper",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "wallpaperHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "thumbnailHash",
				"type": "bytes32"
			}
		],
		"name": "newWallpaper",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "wallpaperHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "thumbnailHash",
				"type": "bytes32"
			}
		],
		"name": "NewWallpaper",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "wallpaperHash",
				"type": "bytes32"
			}
		],
		"name": "setDefaultWallpaper",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
        ];

        this.contractAddress = '0x21e424dB64f6597B60E179AAA7C819E616F801A0';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default WallpaperContract;
